"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { ShieldPlus, RotateCcw, User } from "lucide-react";

export default function ProtectedError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("errors");

  return (
    <div className="flex flex-1 items-center justify-center px-4 py-20">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-xl bg-destructive/10">
          <ShieldPlus className="h-7 w-7 text-destructive" />
        </div>

        <h1 className="text-lg font-semibold tracking-tight">
          {t("routeErrorTitle")}
        </h1>

        <p className="mx-auto mt-2 max-w-xs text-sm leading-relaxed text-muted-foreground">
          {t("routeErrorDescription")}
        </p>

        <div className="mt-6 flex flex-col items-center gap-2 sm:flex-row sm:justify-center">
          <Button onClick={reset}>
            <RotateCcw className="mr-1.5 h-4 w-4" />
            {t("tryAgain")}
          </Button>
          <Button variant="outline" nativeButton={false} render={<Link href="/profile" />}>
            <User className="mr-1.5 h-4 w-4" />
            {t("goToProfile")}
          </Button>
        </div>
      </div>
    </div>
  );
}
